import * as React from 'react'
import MessagingLabel, { type MessagingLabelVariant } from './MessagingLabel'

type Variant = 'confirmation' | 'cancelled' | 'cancelledLow' | 'pending' | 'added'

const variantMap: Record<Variant, MessagingLabelVariant> = {
  confirmation: 'success',
  cancelled: 'critical-high',
  cancelledLow: 'critical-low',
  pending: 'warning',
  added: 'success',
}

interface Props {
  children: React.ReactNode
  variant: Variant
  className?: string
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
}

function StatusLabel(props: Props) {
  const { variant, startIcon, endIcon, ...rest } = props

  return <MessagingLabel
    {...rest}
    variant={variantMap[variant]}
    startIcon={startIcon}
    endIcon={endIcon}
  />
}

export default StatusLabel
